module.exports = __webpack_public_path__ + "static/media/11.09cc297a.png";